import { PageLocatorMap } from '../types/PageLocatorMap';

export const signOutPage = {
  alert: {
    error: 'signout-page.alert.error',
    signupLink: 'signout-page.alert.signup-link',
  },
  footer: {
    root: 'signout-page.footer.root',
  },
  form: {
    h1: 'signout-page.form.heading1',
    phoneInput: 'signout-page.form.phone-input',
    phoneInputError: 'signout-page.form.phone-error',
    root: 'signout-page.form.root',
    signupLink: 'signout-page.form.signup-link',
    submitButton: 'signout-page.form.submit-button',
  },
  header: {
    signupLink: 'signout-page.header.signup-link',
  },
} as const satisfies PageLocatorMap;
